import { useState } from 'react';
import { Button } from '@mantine/core';
import { FileText } from 'react-feather';
import { coachSessionPrepApi } from '../../../../services/api/coachSessionPrep';

/**
 * MED-793 / AC13 — "View Prep Sheet" button. Opens the print-ready PDF
 * generated by PrepSheetPdfService in a new tab.
 *
 * MED-1104: `openPrepSheetPdf` is now async (it fetches the authenticated PDF
 * blob before opening it). We track a loading state so the button shows a
 * spinner and is disabled while the request is in flight — this also prevents
 * double-clicks from spawning duplicate fetches/tabs.
 */

interface ViewPrepSheetButtonProps {
  sessionId: string;
}

export function ViewPrepSheetButton({ sessionId }: ViewPrepSheetButtonProps) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await coachSessionPrepApi.openPrepSheetPdf(sessionId);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="filled"
      color="dark"
      size="sm"
      radius="md"
      leftSection={<FileText size={14} />}
      loading={loading}
      onClick={handleClick}
    >
      View Prep Sheet
    </Button>
  );
}
